import React, { ChangeEvent, Component } from "react";
import ReactDOM from "react-dom";
import { IaddChallengePromptComponentProps } from "../types/props";
import { IaddChallengePromptComponentState } from "../types/states";
import "./addChallengePromptComponent.scss";
class AddChallengePromptComponent extends Component<
  IaddChallengePromptComponentProps,
  IaddChallengePromptComponentState
> {
  constructor(props: IaddChallengePromptComponentProps) {
    super(props);
    this.state = {
      skipNextPrompt: this.props.promptEnabled ? "" : "skip",
    };
  }
  render() {
    const portal = ReactDOM.createPortal(
      <div
        className="pdf-add-challenge-prompt"
        onClick={(event) => event.stopPropagation()}
      >
        <p>
          You are about to create a customized PDF based on the inputs shown.
          Would you like to continue?
        </p>
        <div className="pdf-add-challenge-prompt--actions">
          <button onClick={this.confirm} className="btn ampri-button-primary"
            data-automation="global-challenges-pdf-speedbump-continue">
            Yes, continue
          </button>
          <button onClick={this.cancel} className="btn ampri-button-secondary">
            No, go back
          </button>
        </div>
        <div className="pdf-add-challenge-prompt--footer">
          <label>
            <input
              type="checkbox"
              name="skip-prompt-next"
              value="skip"
              onChange={this.handleNextChange}
            />{" "}
            Do not show this message again
          </label>
        </div>
      </div>,
      document.getElementById("pdf-challenge--modal")
    );
    return <>{portal}</>;
  }
  confirm = () => {
    this.props.confirm(this.state.skipNextPrompt === "skip");
  };

  cancel = () => {
    this.props.cancel();
  };

  handleNextChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.setState({
      skipNextPrompt: event.target.value,
    });
  };
}

export default AddChallengePromptComponent;
